module.exports = __webpack_public_path__ + "img/AudiR8.de1e2556.jpeg";